<template>
  <div v-if="preview" class="picture-preview" role="dialog" aria-modal="true" :aria-label="preview.title || '图片预览'" @click.self="$emit('close')">
    <button type="button" class="picture-preview__close" aria-label="关闭预览" @click="$emit('close')">&times;</button>
    <div class="picture-preview__inner" @click.stop>
      <img class="picture-preview__img" :src="preview.src" :alt="preview.title || '预览'" />
      <p v-if="preview.title" class="picture-preview__caption">{{ preview.title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PicturePreviewModal',
  props: { preview: { type: Object, default: null } },
  watch: {
    preview(val) { document.body.style.overflow = val ? 'hidden' : '' }
  },
  mounted() {
    if (this.preview) document.body.style.overflow = 'hidden'
    this._onKeydown = e => { if (e.key === 'Escape' && this.preview) this.$emit('close') }
    document.addEventListener('keydown', this._onKeydown)
  },
  beforeDestroy() {
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this._onKeydown)
  }
}
</script>

<style scoped>
.picture-preview {
  position: fixed; inset: 0; z-index: 100; display: flex; align-items: center; justify-content: center;
  padding: clamp(0.75rem, 4vw, 1.25rem);
  padding-top: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-top));
  padding-bottom: max(clamp(0.75rem, 4vw, 1.25rem), env(safe-area-inset-bottom));
  background: rgba(0,0,0,0.88); box-sizing: border-box;
}
.picture-preview__close {
  position: absolute; top: max(0.5rem, env(safe-area-inset-top)); right: max(0.5rem, env(safe-area-inset-right));
  width: 2.5rem; height: 2.5rem; border: none; border-radius: 50%; background: rgba(255,255,255,0.15);
  color: #fff; font-size: 1.75rem; line-height: 1; cursor: pointer;
  display: flex; align-items: center; justify-content: center; z-index: 1;
}
.picture-preview__inner {
  max-width: 100%; max-height: 100%; display: flex; flex-direction: column; align-items: center;
  gap: 0.75rem; overflow: auto; -webkit-overflow-scrolling: touch;
}
.picture-preview__img {
  max-width: 100%; width: auto; height: auto; max-height: min(85vh, calc(100vh - 5rem));
  object-fit: contain; border-radius: clamp(0.25rem, 1.5vw, 0.5rem);
}
.picture-preview__caption {
  margin: 0; padding: 0 0.5rem; font-size: clamp(0.8125rem, 3vw, 0.875rem);
  font-weight: 600; color: #e2e8f0; text-align: center; line-height: 1.4; word-break: break-word;
}
</style>
